/**
 * Socket.IO client URL for real-time events (e.g. force_logout on deactivation).
 * Derives from API base URL so socket server is same origin by default.
 */
export function getSocketUrl(): string {
  const env = import.meta.env.VITE_SOCKET_URL;
  if (env && typeof env === "string") return env;
  try {
    const apiBase = import.meta.env.VITE_API_BASE_URL || "http://localhost:3000/api";
    const url = new URL(apiBase);
    return url.origin;
  } catch {
    return "http://localhost:3000";
  }
}

export const FORCE_LOGOUT_REASON_KEY = "tickettrax_force_logout_reason";
